import { z } from 'zod';

export const CoreIntegrationEsriSettingScalarFieldEnumSchema = z.enum(['id','cityId','userId','createdAt','startedAt','name','mapUrl','authType','authUser','authPasswordEncrypted','authUrl','apiKey','lastTestConnectionSuccessAt','lastTestConnectionError','adminContactEmails','adminNotes']);

export default CoreIntegrationEsriSettingScalarFieldEnumSchema;
